<template>
<div>
  <div class="columns" v-if="isData">
        <div class="column is-4">
                <table class="table mark" style="margin:auto;">
                    <tbody v-html="mark"></tbody>
                </table>
                <p class="title is-3">{{guild}}</p>

                        <ul class="is-size-5">
                            <li class="has-text-light">Puntuación: {{guild_detail.score}}</li>
                            <li class="has-text-light">Miembros: {{members.length}} </li>
                        </ul>

        </div>
        <div class="column">
            <div class="card">
                <div class="card-content">
                    <div class="table-container">
                        <table class="table is-striped is-fullwidth">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Raza</th>
                                    <th><abbr title="Grand Resets">G.R.</abbr></th>
                                    <th><abbr title="Resets">R.</abbr></th>
                                    <th><abbr title="Nivel">Lvl.</abbr></th>
                                    <th>Conexión</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="m in members" :key="m.name">
                                    <td><b><fa icon="crown" class="has-text-warning" v-if="m.is_master" v-tooltip="{ content: 'Maestro de Gremio' }" /> {{m.character.name}}</b></td>
                                    <td>{{charClass(m.character.class_field)}}</td>
                                    <td>{{m.character.grandresets}}</td>
                                    <td>{{m.character.resets}}</td>
                                    <td>{{m.character.clevel}}</td>
                                    <td><span class="has-text-primary" v-if="m.character.is_online">En Línea</span><span v-else class="has-text-grey">Desconectado</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


        </div>
  </div>
<p class=" error-box is-size-3" v-else>
    <span class="mu-font is-uppercase">No se ha encontrado el gremio </span> <br>
    {{guild}}
</p>
</div>

</template>

<script>
export default {
    name:'Guild',
    data:()=>({
        isData: false,
        guild: '',
        members: [],
        mark:'',
        guild_detail:{}
    }),
    computed: {
        endpoint() {
            return this.$store.getters.GetEndpoints.guild.detail
        },
        api() {
            return this.$store.getters.GetApiPath
        },
        charClass() {
            return this.$store.getters.GetCharacterBreed
        }
    },
    beforeCreate(){
        this.$store.commit('setLoader', true)
        this.$store.dispatch('setPage', {
            location:{name:'gremios',number:13},
            title:'Gremio '+this.$route.params.id,
            breadcrumb:[
                {name:'inicio',link:this.$store.state.baseUrl,active:true,icon:'home'},
                {name:'Gremios',link:`${this.$store.state.baseUrl}ranking/gremios`,active:true,icon:'users'},
                {name:this.$route.params.id,link:'/gremios/'+this.$route.params.id, active:false, icon:'torii-gate'}
            ]
        })
    },
    async mounted() {
        this.guild = this.$route.params.id
        // var path = this.api+this.endpoint+'?name='+this.guild
        // let {data} = await this.$http.get(path)
        const guildDetails = this.$store.getters.GetJson('guild-detail')['guild']
        let data = guildDetails.filter(x => x.name === this.guild)
        console.log(data)
        if(data.length > 0) {
            this.isData=true
            var guild = data[0]
            this.guild_detail = guild
            this.members = guild.members
            var count = 1
            this.mark+= '<tr>'
            for (var mark in guild.mark) {
                
                this.mark+= `<td style="background-color:${guild.mark[mark] != "" ? guild.mark[mark]:'rgba(0, 0, 0, 0)' };"></td>`
                
                if(count>=8) (mark < 63 ? this.mark+='</tr><tr>': this.mark+='</tr>', count=0)
                count++
            }
            
        }
        
        this.$store.commit('setLoader', false)
    }
}
</script>

<style scoped>
    .table.mark {
        background-color: inherit !important;
    }

</style>